"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDashboard = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const theme_1 = __importDefault(require("../../components/styles/theme"));
const DEFAULT_svg_1 = __importDefault(require("../../../71eb904/assets/images/tiles/DEFAULT.svg"));
exports.StyledDashboard = styled_1.default.div `
.tbp-property-dashboard__container {
    font-family: ${theme_1.default.typography.fonts.base};
}

.tbp-property-dashboard__container .merlin-button {
	/*portal styling override*/
	box-shadow: none;
}

.tbp-property-dashboard__toggle-icon .merlin-button {
	/*portal styling overrides*/
	padding: 0;
	line-height: 1;
	height: auto;
}

.tbp-property-dashboard__loader {
	height: 50px;
	margin: 20px 0;
}

.tbp-property-dashboard__container h1,
.tbp-property-dashboard__container h2 {
	font-weight: 500;
	color: #444444;
	font-size: 1.5rem;
}

.tbp-property-dashboard__container p {
	font-weight: 300;
}

.tbp-property-dashboard__head {
	padding: 0 0 20x 0;
	position: relative;
	background: url(${DEFAULT_svg_1.default});
	background-position: -500px top;
	background-repeat: no-repeat;
	background-size: auto 451px; // this is the height of the container
	@media only screen and (min-width: 768px) {
		background-position: center top; //offset the svg to prevent white packground
	}
}

/* tiles */

.tbp-property-dashboard__tile {
	position: relative;
	z-index: 1;
}

.tbp-property-dashboard__tile > div {
	border-radius: 10px;
	border: solid 1px ${theme_1.default.colours.neutral.light};
}

.tbp-property-dashboard__tile h2 {
	margin-top: -30px;
}

.tbp-property-dashboard__tile-number {
	color: #fff;
	background: #1E6CF8;
	font-size: 32px;
	border-radius: 50%;
	width: 50px;
	height: 50px;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	line-height: 1;
	font-weight: 500;
	position: relative;
	top: -45px;
	box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
}

/* non-carousel tiles */

.carousel-item>*,
.tbp-property-dashboard__tile>* {
	height: 100%;
}

@media only screen and (min-width: 820px) {
	.tbp-property-dashboard__tiles {
		display: flex;
		height: 320px;
	}

	.tbp-property-dashboard__tile {
		flex-basis: 100%;
		max-width: 335px;
	}

	.tbp-property-dashboard__tile:not(:first-of-type) {
		margin-left: 20px;
	}
}

/* dashboard links */

.tbp-property-dashboard__link {
	margin: 20px 0;
}

tbp-property-dashboard__link a:not(.merlin-button) {
	text-decoration: none;
	color: ${theme_1.default.colours.text.darker};
}

.property__completeness {
	background: #888;
	color: #fff;
	width: 20px;
	height: 20px;
	min-width: 20px;
	display: inline-flex;
	flex-basis: 20px;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	margin-right: 20px;
}

.property__completeness--complete {
	background: #007A5C;
}
`;
//# sourceMappingURL=Dashboard.styled.js.map